<template>
  <div class="container-full">
    <div class="sub-center">
      <template v-show="verified">
        <div class="_for-center">
          <div class="zoom">
            <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
          </div>
        </div>
        <span class="font-30  d-block font-weight-5 text-green">Congratulation</span>
        <span class="font-20">Your Account Has been Verify</span> 
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'account-verification',
  data() {
    return {
      verified: false
    }
  },
  mounted() {
    this.$axios.post(`/auth/verify-email/${this.$route.params.id}`)
      .then( () => { 
        this.verified = true
      }).catch( () => {
        this.$router.push('/pages/500')
      })
  }  
}
</script>